export const ATTENDANCE_SUMMARY_PERMISSION_CODES = {
    WEB_ATTENDANCE_SUMMARY_LIST: 'WEB_ATTENDANCE_SUMMARY_LIST',
    WEB_ATTENDANCE_SUMMARY_DETAIL: 'WEB_ATTENDANCE_SUMMARY_DETAIL',
    WEB_ATTENDANCE_SUMMARY_ADD: 'WEB_ATTENDANCE_SUMMARY_ADD',
    WEB_ATTENDANCE_SUMMARY_EDIT: 'WEB_ATTENDANCE_SUMMARY_EDIT',
    WEB_ATTENDANCE_SUMMARY_DELETE: 'WEB_ATTENDANCE_SUMMARY_DELETE',
    WEB_ATTENDANCE_SUMMARY_IMPORT: 'WEB_ATTENDANCE_SUMMARY_IMPORT',
    WEB_ATTENDANCE_SUMMARY_EXPORT: 'WEB_ATTENDANCE_SUMMARY_EXPORT',
} as const;

